import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { observer } from "mobx-react";
import { Box, Grid, Hidden } from "@material-ui/core";
import { Centered, CircularProgress, Typography, Space, Divider, Button } from "../../../common/components/libs";
import { Pagination } from "@material-ui/lab";
import CouponCard from "./components/CouponCard";
import CouponsList from "./components/CouponsTable";
import { useStores } from "../../../hooks";
import ChooseMenu from "./components/ChooseMenu";
import CreateCouponForm from "./components/forms/CreateCouponForm";
import { CouponsFormType } from "../store/forms";
import ChooseCoupon from "./components/ChooseCoupon";
import { SnackbarType } from "../../../stores/common";
import {Trans, useTranslation} from "react-i18next";


const CouponsListPage = () => {
    const { generalStore, couponsStore } = useStores();
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const {i18n, t, ready} = useTranslation(["general", "coupons"], { useSuspense: false });
    const locale = i18n.language;
    useEffect(() => {
        generalStore.setPageTitle(t("coupons:title"));
        couponsStore.init().then(() => couponsStore.getCoupons()).then(() => {
            setIsDataLoaded(true);
        });
    }, [couponsStore, generalStore, ready]);

    const { coupons } = couponsStore;

    const page = couponsStore.getPage();
    const pages = couponsStore.getPages();


    const handleChangePage = (event, value) => {
        couponsStore.setPage(value);
        couponsStore.setSkip((value - 1) * couponsStore.getLimit());
        couponsStore.getCoupons();
    };

    const deleteCoupon = (couponId: number) => {
        couponsStore.deleteCoupon(couponId);
        generalStore.showSnackbar({
            title: t("coupons:labelOfDeleting"),
            type: SnackbarType.success
        })
    };

    if (!isDataLoaded) {
        return (
            <Centered>
                <CircularProgress m={2}/>
            </Centered>
        );
    } else {
        return (
            <>
                <Helmet title={t("coupons:coupon")}/>
                <CreateCouponForm/>
                <Typography variant='h6'>
                    {t("coupons:title")}
                </Typography>
                <ChooseMenu/>
                <ChooseCoupon/>

                {couponsStore.menusIds.length > 0 &&
                <Button
                  mt={2}
                  onClick={() => {
                      couponsStore.forms.showPopupForm(CouponsFormType.createCoupon);
                  }}
                  fullWidth
                  variant={'outlined'}
                  color={'default'}
                >
                    {t("general:add")}
                </Button>
                        }
                    {/*</Grid>*/}
                {/*</Grid>*/}
                <Divider my={6}/>
                {coupons?.length > 0 ?
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                                <CouponsList
                                    coupons={coupons}
                                    delete={deleteCoupon}
                                    edit={couponsStore.updateCoupon}
                                    showForm = {couponsStore.forms.showPopupForm}
                                />
                            </Box>
                            <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                                {coupons.map((coupon) => {
                                    return (
                                        <>
                                            <CouponCard
                                                coupon={coupon}
                                                key={coupon.id}
                                                delete={deleteCoupon}
                                                edit={couponsStore.updateCoupon}
                                                showForm = {couponsStore.forms.showPopupForm}
                                                usages={couponsStore.getActivationsByCoupon(coupon.id)}
                                            />
                                            <Space size={10}/>
                                        </>
                                    );
                                })}
                            </Box>
                            <Centered>
                                <Pagination count={pages} page={page} onChange={handleChangePage}/>
                            </Centered>
                        </Grid>
                    </Grid>
                    : <Typography variant="body1" ml={2}>
                        {t("coupons:notFoundCoupons")}
                    </Typography>
                }

            </>
        );
    }

};

export default observer(CouponsListPage);
